"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._Mixin = void 0;
exports.createBootstrapper = createBootstrapper;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _Bootstrapper2 = _interopRequireDefault(require("../Bootstrapper"));
var _ContainerBuilder = _interopRequireDefault(require("../builder/ContainerBuilder"));
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } } /**
                                                                                                                                                                                                                                                                                                                                           * Copyright 2016-present, Deloitte Digital.
                                                                                                                                                                                                                                                                                                                                           * All rights reserved.
                                                                                                                                                                                                                                                                                                                                           *
                                                                                                                                                                                                                                                                                                                                           * This source code is licensed under the BSD-3-Clause license found in the
                                                                                                                                                                                                                                                                                                                                           * LICENSE file in the root directory of this source tree.
                                                                                                                                                                                                                                                                                                                                           */
/*
* Mixin class used for extending the classic spec
* @private
*/
var _Mixin = /*#__PURE__*/function (_Bootstrapper) {
  (0, _inherits2.default)(_Mixin, _Bootstrapper);
  var _super = _createSuper(_Mixin);
  /*
  * A Constructor that takes a spec
  */
  function _Mixin(spec, callback) {
    var _this;
    (0, _classCallCheck2.default)(this, _Mixin);
    _this = _super.call(this);

    // Check if a container spec was supplied
    if (!spec.container) {
      console.warn('"Container" property was not supplied');
      return (0, _possibleConstructorReturn2.default)(_this);
    }

    // Set the component selector if defined
    if (spec.componentSelector) {
      _this.componentSelector = spec.componentSelector;
    }

    // Set the watcher value if defined
    if (typeof spec.enableWatcher === 'boolean') {
      _this.enableWatcher = spec.enableWatcher;
    }

    // Create a new container
    var containerBuilder = new _ContainerBuilder.default(spec.defaultOptions || null);

    // Map the components
    for (var i = 0; i < spec.container.length; i++) {
      var registration = void 0;
      if (spec.container[i].forAsync) {
        registration = containerBuilder.registerAsync(spec.container[i].forAsync).as(spec.container[i].register);
      } else {
        registration = containerBuilder.register(spec.container[i].for).as(spec.container[i].register);
      }
      if (spec.container[i].withDefaultProps) {
        registration.withDefaultProps(spec.container[i].withDefaultProps);
      }
      if (spec.container[i].withOptions) {
        registration.withOptions(spec.container[i].withOptions);
      }
    }
    _this._shouldUpdateProxy = spec.shouldUpdate || null;
    _this._willUpdateProxy = spec.willUpdate || null;
    _this._didUpdateProxy = spec.didUpdate || null;
    _this._willUnmountProxy = spec.willUnmountHabitats || null;
    _this._didUnmountProxy = spec.didUnmountHabitats || null;
    _this._didDisposeProxy = spec.didDispose || null;

    // Finally, set the container
    _this.setContainer(containerBuilder.build(), function () {
      if (typeof callback === 'function') {
        callback();
      }
    });
    return _this;
  }
  (0, _createClass2.default)(_Mixin, [{
    key: "shouldUpdate",
    value: function shouldUpdate(node) {
      if (this._shouldUpdateProxy) {
        this._shouldUpdateProxy(node);
      }
    }
  }, {
    key: "willUpdate",
    value: function willUpdate() {
      if (this._willUpdateProxy) {
        this._willUpdateProxy();
      }
    }
  }, {
    key: "didUpdate",
    value: function didUpdate() {
      if (this._didUpdateProxy) {
        this._didUpdateProxy();
      }
    }
  }, {
    key: "willUnmountHabitats",
    value: function willUnmountHabitats() {
      if (this._willUnmountProxy) {
        this._willUnmountProxy();
      }
    }
  }, {
    key: "didUnmountHabitats",
    value: function didUnmountHabitats() {
      if (this._didUnmountProxy) {
        this._didUnmountProxy();
      }
    }
  }, {
    key: "didDispose",
    value: function didDispose() {
      if (this._didDisposeProxy) {
        this._didDisposeProxy();
      }
    }
  }]);
  return _Mixin;
}(_Bootstrapper2.default);
/*
* The classic bootstrapper
*/
exports._Mixin = _Mixin;
function createBootstrapper(spec) {
  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return new _Mixin(spec, cb);
}